<template>
  <div class="flex flex-col gap-y-3">
    <Field :rules="isRequired" name="passportNumber" v-slot="{ field, errors: errs }">
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('passportNumber')"
        :maxlength="20"
        direction="flex-col"
      />
    </Field>

    <Field :rules="isRequired" name="passportTypeId" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDropdown
        :field="field"
        :errors="errs"
        :label="$t('passportTypes')"
        :options="currentVisaStore.passportTypes"
        direction="flex-col"
        @on-selection="(item) => handleChange(+item?.id)"
      ></SimpleDropdown>
    </Field>
    <Field :rules="isRequired" name="dateOfBirth" v-slot="{ field, errors: errs, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errs"
        :label="$t('dateOfBirth')"
        server-date-format="yyyy-MM-dd"
        max-date="__now__"
        @on-change="(date) => handleChange(date)"
      >
      </SimpleDatepicker>
    </Field>
    <Field
      :rules="isRequired"
      name="currentNationalityId"
      v-slot="{ field, errors: errs, handleChange }"
    >
      <SimpleDropdown
        :field="field"
        :errors="errs"
        :label="$t('currentNationality')"
        :options="currentVisaStore.countries"
        direction="flex-col"
        @on-selection="(item) => handleChange(+item?.id)"
      ></SimpleDropdown>
    </Field>
  </div>
</template>

<script setup>
import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import { Field } from 'vee-validate'
import { useCurrentVisaStore } from '@/stores/current_visa'

defineProps({
  initialValues: { type: Object },
  errors: {
    type: Object
  },
  values: {
    type: Object
  },
  resetField: {
    type: Function
  },
  setFieldValue: {
    type: Function
  }
})

function isRequired(value) {
  if (value && `${value}`.trim()) {
    return true
  }

  return 'INVALID_REQUIRED'
}

const currentVisaStore = useCurrentVisaStore()
</script>

<style lang="scss" scoped></style>
